var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccount({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1661_6369",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 28,
    height: 29
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 28,
    height: 28,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1661_6369)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 15.6667C15.1278 15.6667 16.0903 15.2681 16.8875 14.4708C17.6847 13.6736 18.0833 12.7111 18.0833 11.5833C18.0833 10.4556 17.6847 9.49306 16.8875 8.69583C16.0903 7.89861 15.1278 7.5 14 7.5C12.8722 7.5 11.9097 7.89861 11.1125 8.69583C10.3153 9.49306 9.91667 10.4556 9.91667 11.5833C9.91667 12.7111 10.3153 13.6736 11.1125 14.4708C11.9097 15.2681 12.8722 15.6667 14 15.6667ZM5.83333 25C5.19167 25 4.64236 24.7715 4.18542 24.3146C3.72847 23.8576 3.5 23.3083 3.5 22.6667V6.33333C3.5 5.69167 3.72847 5.14236 4.18542 4.68542C4.64236 4.22847 5.19167 4 5.83333 4H22.1667C22.8083 4 23.3576 4.22847 23.8146 4.68542C24.2715 5.14236 24.5 5.69167 24.5 6.33333V22.6667C24.5 23.3083 24.2715 23.8576 23.8146 24.3146C23.3576 24.7715 22.8083 25 22.1667 25H5.83333ZM5.83333 22.6667H22.1667V21.325C21.1167 20.2944 19.8965 19.4826 18.5062 18.8896C17.116 18.2965 15.6139 18 14 18C12.3861 18 10.884 18.2965 9.49375 18.8896C8.10347 19.4826 6.88333 20.2944 5.83333 21.325V22.6667Z",
    fill: "#EAD40C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccount);
export default __webpack_public_path__ + "static/media/account.38c33e036ab07a790644865a027ec35e.svg";
export { ForwardRef as ReactComponent };